import React from "react";

import { Row, Col } from "reactstrap";

export default () => (
	<Row className="mt-4">
		<Col>
			<p>
				If we need more information to verify your identity or to better understand the nature of your request, we will let you know. We will endeavor to respond
				to a verified request within 45 days unless there are grounds for extending our response timeframe by up to an additional 45 days. In the event of an
				extension, we will explain to you why the extension is necessary. If we cannot fulfill your request because we cannot verify your identity or due to
				exceptions under the CPRA (or when the CPRA does not apply to the personal information), we'll let you know in our response
			</p>
			<p>
				In some cases, your ability to know/access, correct, or delete your personal information will be limited, as required or permitted by applicable law,
				even when the CPRA applies to the personal information we have for you.
			</p>
		</Col>
	</Row>
);
